import React from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

import { AWSMonitorSelection } from 'components/status-checks/form/status-check/aws/AWSMonitorSelection'
import { DatadogMonitorSelection } from 'components/status-checks/form/status-check/datadog/DatadogMonitorSelection'
import { StatusCheckFormValues } from 'components/status-checks/status-checks-form-utils'
import { ObservabilityToolType } from 'types/api/status-checks/status-check'

export const StatusCheckMonitorSelection: React.FC = () => {
  const { control } = useFormContext<StatusCheckFormValues>()

  const observabilityTool = useWatch<StatusCheckFormValues>({
    control,
    name: 'observabilityTool'
  })

  switch (observabilityTool.type) {
    case ObservabilityToolType.AWS:
      return <AWSMonitorSelection />
    default:
      return <DatadogMonitorSelection />
  }
}
